import React, { useEffect, useRef, useState } from 'react';
import apiClient from '../services/apiClient';
import defaultNoteCover from '../assets/note-covers/default-note-cover.svg';

const coverRequests = new Map();

function fetchCoverOnce(presetId) {
  if (!coverRequests.has(presetId)) {
    const request = apiClient.fetchPresetLibraryCover(presetId)
      .catch((error) => {
        coverRequests.delete(presetId);
        throw error;
      });
    coverRequests.set(presetId, request);
  }
  return coverRequests.get(presetId);
}

function PresetLibraryCoverImage({ presetId, hasCover, alt = '', className = '' }) {
  const imageRef = useRef(null);
  const [source, setSource] = useState(defaultNoteCover);

  useEffect(() => {
    setSource(defaultNoteCover);
    if (!hasCover) {
      return undefined;
    }

    let cancelled = false;
    let objectUrl = '';
    let observer = null;

    const loadCover = () => {
      fetchCoverOnce(presetId)
        .then((blob) => {
          if (cancelled) return;
          objectUrl = URL.createObjectURL(blob);
          setSource(objectUrl);
        })
        .catch((error) => {
          if (!cancelled && error?.name !== 'AbortError') setSource(defaultNoteCover);
        });
    };

    if (typeof IntersectionObserver === 'function' && imageRef.current) {
      observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        loadCover();
      }, {
        rootMargin: '240px',
        threshold: 0.01,
      });
      observer.observe(imageRef.current);
    } else {
      loadCover();
    }

    return () => {
      cancelled = true;
      observer?.disconnect();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [hasCover, presetId]);

  return (
    <img
      ref={imageRef}
      src={source}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={`${className}${source === defaultNoteCover ? ' is-fallback' : ''}`.trim()}
    />
  );
}

export default PresetLibraryCoverImage;
